import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { Apollo } from 'apollo-angular';
import{HttpClient} from '@angular/common/http'

import * as gqlKardex from "../graphql/gql_kardex"
import { HojaVida } from "../models/hojavida"
import { Estudio } from "../models/estudio"
import { Curso } from "../models/curso"
import { DecJurada,Parentesco } from "../models/decjurada"
import { Experiencia } from "../models/experiencia"
import {global} from '../../../graphqlserver/conection';

@Injectable({
    providedIn: 'root'
})
export class KardexService {

    constructor(private apollo: Apollo, private http:HttpClient) { }

    getHojaVidaByCi(ci:string){
        return this.apollo.watchQuery<any>({
          query: gqlKardex.gql_getHojaVidaByCi,
          variables:{ci}
        }).valueChanges.pipe(map(result => result.data.getHojaVidaByCi));
      };

    listahojavida(ci:string){
        return this.apollo.watchQuery<any>({
          query: gqlKardex.gql_listahojavida,
          variables:{ci}
        }).valueChanges.pipe(map(result => result.data.listahojavida));
    };

    listaUsuariosConHojaVida(ci:string){
        return this.apollo.watchQuery<any>({
          query: gqlKardex.gql_listaUsuariosConHojaVida,
          variables:{ci}
        }).valueChanges.pipe(map(result => result.data.listaUsuariosConHojaVida));
    };

    public creaOActualizaHojaDeVida(datos: HojaVida) {
        return this.apollo.mutate({
            mutation: gqlKardex.gql_creaOActualizaHojaDeVida,
            variables: { datos }
        })
    }

    public creaOActualizaEstudios(datos: [Estudio], codHoja: number) {
        return this.apollo.mutate({
            mutation: gqlKardex.gql_creaOActualizaEstudios,
            variables: { datos,codHoja }
        })
    }

    public creaOActualizaCursos(datos: [Curso], codHoja: number) {
        return this.apollo.mutate({
            mutation: gqlKardex.gql_creaOActualizaCursos,
            variables: { datos,codHoja }
        })
    }

    public creaOActualizaExperiencia(datos: [Experiencia], codHoja: number) {
        return this.apollo.mutate({
            mutation: gqlKardex.gql_creaOActualizaExperiencia,
            variables: { datos,codHoja }
        })
    }

    public deleteElement(idelement:number, tablename:string, tableid:string) {
        return this.apollo.mutate({
            mutation: gqlKardex.gql_deleteElement,
            variables: { idelement,tablename,tableid }
        })
    }

    public aprobarKardex(personal:string, ci:string) {
        return this.apollo.mutate({
            mutation: gqlKardex.gql_aprobarkardex,
            variables: { personal,ci }
        })
    }

    public ListaKardexGral(habil:string) {
        return this.apollo.watchQuery<any>({
            query: gqlKardex.gql_listakardexgral,
            variables:{habil}
        }).valueChanges.pipe(map(result => result.data.listadoCVGeneral));
    }

    public cambiaedicion(ci:string,valor:boolean) {
        return this.apollo.mutate({
            mutation: gqlKardex.gql_cambiaedicion,
            variables: { ci,valor }
        })
    }

    public cambiahabilitado(ci:string,valor:string) {
        return this.apollo.mutate({
            mutation: gqlKardex.gql_cambiahabilitado,
            variables: { ci,valor }
        })
    }

    listadecjurada(ci:string){
        return this.apollo.watchQuery<any>({
          query: gqlKardex.gql_listaDecJurada,
          variables:{ci}
        }).valueChanges.pipe(map(result => result.data.listaDecJurada));
    };

    listaparentesco(ci:string){
        return this.apollo.watchQuery<any>({
          query: gqlKardex.gql_listaParentesco,
          variables:{ci}
        }).valueChanges.pipe(map(result => result.data.listaParentesco));
    };

    public actualizaparentesco(datos:Parentesco) {
        return this.apollo.mutate({
            mutation: gqlKardex.gql_Actualizaparentesco,
            variables: { datos }
        })
    }

    public actualizadecjurada(datos:DecJurada) {
        return this.apollo.mutate({
            mutation: gqlKardex.gql_Actualizadecjurada,
            variables: { datos }
        })
    }

    public elimininadecjurada(cod:string) {
        return this.apollo.mutate({
            mutation: gqlKardex.gql_eliminadecjurada,
            variables: { cod }
        })
    }

    public eliminaParentesco(cod:number) {
        return this.apollo.mutate({
            mutation: gqlKardex.gql_eliminaParentesco,
            variables: { cod }
        })
    }

    public estadoEditar(valor:boolean) {
        return this.apollo.mutate({
            mutation: gqlKardex.gql_estadoeditar,
            variables: {valor}
        })
    }

    fileupload(file){
        var url=global.urlgraph+'/upload';
        return this.http.post(url,file);
    }

    photoupload(file,ci:string){
        var url=global.urlgraph+'/uploadF/'+ci;
        return this.http.post(url,file);
    }

}
